import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, DatePickerUI } from '../Interface';

const BatchSnFields = ({ viewField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="itemCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Cikkszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemCode} />}
          disabled
          InputLabelProps={{ shrink: values.itemCode && values.itemCode !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="batchSn"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Sarzs" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.batchSn} />}
          disabled
          InputLabelProps={{ shrink: values.batchSn && values.batchSn !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="date"
          name="addDate"
          component={DatePickerUI}
          value={values.addDate}
          fullWidth
          label={<FormLabelUI text="Beérkezés dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.addDate} />}
          disabled
          InputLabelProps={{ shrink: Boolean(values.addDate) }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="lot"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="LOT" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.lot} />}
          disabled
          InputLabelProps={{ shrink: values.lot && values.lot !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="supplierId"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Beszállító azon." />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierId} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierId && values.supplierId !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="date"
          name="expDate"
          component={DatePickerUI}
          value={values.expDate}
          fullWidth
          label={<FormLabelUI text="Lejárat" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.expDate} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.expDate) }}
          onChange={(date) => {
            setFieldValue('expDate', date).then(() => {
              validateField('expDate');
            });
          }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="date"
          name="mnfDate"
          component={DatePickerUI}
          value={values.mnfDate}
          fullWidth
          label={<FormLabelUI text="Gyártás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.mnfDate} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.mnfDate) }}
          onChange={(date) => {
            setFieldValue('mnfDate', date).then(() => {
              validateField('mnfDate');
            });
          }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="batchAttribute1"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Attribútum 1" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.batchAttribute1} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.batchAttribute1 && values.batchAttribute1 !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="batchAttribute2"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Attribútum 2" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.batchAttribute2} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.batchAttribute2 && values.batchAttribute2 !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="number"
          name="price"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Ár" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.price} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.price && values.price !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="other"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Egyéb" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.other} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.other && values.other !== '' }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="comment"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.comment} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.comment && values.comment !== '' }}
          multiline
          rows={2}
        />
      </div>
    </div>
  );
};

export default BatchSnFields;
